import { Component, Input } from '@angular/core';
import { Action, BackendDataSourceService, DataSource } from '@ntap/core';

@Component({
  selector: 'app-editable-table-additional-actions',
  templateUrl: './editable-table-additional-actions.component.html',
  providers: [
    {
      provide: BackendDataSourceService,
      useClass: BackendDataSourceService
    },
    {
      provide: DataSource,
      useExisting: BackendDataSourceService
    }
  ]
})
export class EditableTableAdditionalActionsComponent {
  @Input() public editableTableActions: any[];

  public isActionVisible(action: Action): boolean {
    return action.target === 'HEADING_ITEM';
  }
}
